import {
  SET_JOB,
  SET_JOBS,
  CLEAR_JOBS,
  SET_SELECTED_JOB
} from '@/system/store/mutation-types'

import { MutationTree, Mutation } from 'vuex'

import {
  IJobStore,
  IJob
} from '@/features/job/store'

const setJob: Mutation<IJobStore> = (state: IJobStore, job: IJob): IJobStore => {
  state.job = { ...state.job, ...job }
  return state
}

const setJobList: Mutation<IJobStore> = (state: IJobStore, { jobs }: any): IJobStore => {
  state.list = [ ...jobs ]
  return state
}

const clearJobs: Mutation<IJobStore> = (state: IJobStore): IJobStore => {
  state.list = []
  return state
}

const setSelectedJob: Mutation<IJobStore> = (state: IJobStore, job: IJob): IJobStore => {
  state.selectedJob = job
  return state
}

const mutations: MutationTree<IJobStore> = {
  [SET_JOB]: setJob,
  [SET_JOBS]: setJobList,
  [CLEAR_JOBS]: clearJobs,
  [SET_SELECTED_JOB]: setSelectedJob
}

export default mutations
